import { ReactScrollLinkProps } from 'react-scroll/modules/components/Link';

// Excluding 'to', we set manually on the component
export type ReusableScrollProps = Omit<ReactScrollLinkProps, 'to'>;

export const scrollConfig: ReusableScrollProps = {
  activeClass: 'active',
  hashSpy: true,
  isDynamic: true,
  spy: true,
  smooth: true,
  duration: 250,
};

export const gridMainformId = 'grid-mainform';

// common metadata bundles
export const commonScrollConfig: ReusableScrollProps = {
  containerId: gridMainformId,
  ...scrollConfig,
};

export const articleContainerId = 'articleform-gridwrapper';

// articles content/hammer/kicker etc
export const articleScrollConfig: ReusableScrollProps = {
  containerId: articleContainerId,
  ...scrollConfig,
};
